import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataInteger
} from "pbas-vue-components";

import { translate } from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'

function getSearchEmployersHeaders(hasStores) {
  if (hasStores) {
    return [
      new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1
    }),
    new ODataHeader({
      type: new ODataString("Current/Name"),
      sortable: true,
      visible: false,
      searchable: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Current/Translations[]/Name", {
        getString: (item) => translate2(item.Current, "Name")
      }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1,
      orderByKey: "Name"
    }),
    new ODataHeader({
      type: new ODataString("Current/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.number",
      type: new ODataString("Current/Number"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("Stores[]/Current/Name"),
      sortable: true,
      visible: false,
      allowVisibilityChange: false,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.stores",
      type: new ODataString("Stores[]/Current/Translations[]/Name", {
        getString: (item) => item.Stores.map(o=>translate2(o.Current, "Name")).join(", "),
        getHtml: (item, type) => {
          return ("<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
            type.getString(item, type) +
            "</div>");
        }
      }),
      sortable: true,
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      version: 2,
      orderByKey: "Name"
    }),
    new ODataHeader({
      type: new ODataString("Stores[]/Current/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "Stores Number",
      type: new ODataString("Stores[]/Current/Number"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),];
  }
  return [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1
    }),
    new ODataHeader({
      type: new ODataString("Current/Name"),
      sortable: true,
      visible: false,
      searchable: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Current/Translations[]/Name", {
        getString: (item) => translate2(item.Current, "Name")
      }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1,
      orderByKey: "Name"
    }),
    new ODataHeader({
      type: new ODataString("Current/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.number",
      type: new ODataString("Current/Number"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
}

export default getSearchEmployersHeaders;